import { render } from "./EnrollmentDocuments.vue?vue&type=template&id=69842698"
import script from "./EnrollmentDocuments.vue?vue&type=script&lang=js"
export * from "./EnrollmentDocuments.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/fms_employee_Portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__